import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { useMemo } from 'react';
import { useMenuContext } from "../../mega-menu-provider";
import { HEADER_HEIGHT } from "../../constants";
import { MenuBackgroundContainer } from "./menu-background.styles";
import { jsx as _jsx } from "react/jsx-runtime";
var MenuBackground = function MenuBackground(_ref) {
  var fixed = _ref.fixed;
  var _useMenuContext = useMenuContext(),
    palette = _useMenuContext.palette,
    transparentBackground = _useMenuContext.transparentBackground,
    isMobileMenu = _useMenuContext.isMobileMenu,
    isMobileMenuOpen = _useMenuContext.isMobileMenuOpen,
    isMenuScrolled = _useMenuContext.isMenuScrolled,
    activeSubMenuItem = _useMenuContext.activeSubMenuItem,
    subMenuElementsRef = _useMenuContext.subMenuElementsRef;
  var computedProps = useMemo(function () {
    var contentHeight = '';
    if (isMobileMenuOpen) {
      contentHeight = "100vh";
    } else if (!isMobileMenu && activeSubMenuItem !== null && activeSubMenuItem !== void 0 && activeSubMenuItem.id) {
      var subMenuContainerElement = subMenuElementsRef === null || subMenuElementsRef === void 0 ? void 0 : subMenuElementsRef.current[activeSubMenuItem.id];
      contentHeight = subMenuContainerElement !== null && subMenuContainerElement !== void 0 && subMenuContainerElement.offsetHeight ? "".concat(subMenuContainerElement.offsetHeight + HEADER_HEIGHT, "px") : '';
    }
    return {
      contentHeight: contentHeight,
      isExpanded: !!contentHeight
    };
  }, [isMobileMenu, isMobileMenuOpen, activeSubMenuItem, subMenuElementsRef]);
  return /*#__PURE__*/_jsx(MenuBackgroundContainer, _objectSpread(_objectSpread({}, computedProps), {}, {
    isMenuScrolled: isMenuScrolled,
    transparentBackground: transparentBackground,
    palette: palette,
    fixed: fixed
  }));
};
export default MenuBackground;